import { useAuth } from '../context/AuthContext';
export type { Organization } from '../context/AuthContext';

export function useOrganization() {
  const { org, orgLoading, refreshOrg, consumePendingInvite } = useAuth();
  return { org, loading: orgLoading, consumePendingInvite, refreshOrg };
}
